'use strict';

const lodashPartialRight = require('lodash.partialright');
const tradeTourRule = require('./tradeTourRule');

const {type: {REQUEST_ITEM_HOLD_TOUR}} = require('../../../components/Tour/TourStore');
const netPriceRule = lodashPartialRight(tradeTourRule, {
    type: REQUEST_ITEM_HOLD_TOUR,
    limit: 1
});

module.exports = netPriceRule;



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/requestItemHoldRule.es.js